export default {
  picture: {
    value: 1,
    subject: "Votre photo Twineeds",
    message: "Bonjour [firstname_fl],\n" +
    "J’ai remarqué que vous n’aviez pas encore chargé votre photo de profil sur votre compte Twineeds.\n" +
    "Il faut que vous sachiez qu’à tort ou à raison, les clients privilégient les profils qui ont une photo de qualité !\n" +
    "Je ne peux que vous recommander d’en ajouter une.\n" +
    "Les standards de Twineeds sont : \n" +
    "\t•\tUne photo de face ou trois-quarts\n" +
    "\t•\tSur fond blanc\n" +
    "\t•\tPrise entre le buste et la tête \n" +
    "\t•\tAvec un sourire si possible ! \n" +
    "Après tout, on a tous envie de travailler avec une personne de bonne humeur. Regardez les photos de la page d’accueil pour vous faire une idée.\n" +
    "Très bonne journée,\n" +
    "[firstname_admin]",
    replace: [
      [new RegExp('\\[firstname_fl\\]'), 'user.firstname'],
      [new RegExp('\\[firstname_admin\\]'), 'admin.firstname'],
    ]
  },
  picture_bis: {
    value: 2,
    subject: "Re: Votre photo Twineeds",
    message: "Bonjour [firstname_fl], \n" +
    "Il y a quelques temps, je vous ai envoyé un mail concernant votre photo de profil sur Twineeds qui n’était pas encore chargée. Je me permets donc de vous faire un petit rappel. \n" +
    "La photo est vraiment un standard de notre plateforme, et cela nous permet d’attirer un maximum de clients pour vous proposer des missions. \n" +
    "Pour rappel les standards de Twineeds sont : \n" +
    "\t•\tUne photo de face ou trois-quarts \n" +
    "\t•\tSur fond blanc \n" +
    "\t•\tPrise entre le buste et la tête \n" +
    "\t•\tAvec un sourire si possible ! \n" +
    "Après tout, on a tous envie de travailler avec une personne de bonne humeur. Regardez les photos de la page d’accueil pour vous faire une idée. \n" +
    "Très bonne journée, \n" +
    "[firstname_admin]",
    replace: [
      [new RegExp('\\[firstname_fl\\]'), 'user.firstname'],
      [new RegExp('\\[firstname_admin\\]'), 'admin.firstname'],
    ]
  },
  experiences: {
    value: 3,
    subject: "Vos expériences professionnelles – Twineeds",
    message: "Bonjour [firstname_fl],\n" +
    "Encore bienvenue chez Twineeds ! Nous sommes ravis de pouvoir vous compter parmi nos utilisateurs. \n" +
    "Je me permet de vous contacter car j’ai pu remarquer que vous n’avez pas encore complété suffisamment vos expériences.\n" +
    "Je dis suffisamment, car nous savons que nos clients n’accordent de la légitimité qu’aux profils les plus complets et détaillés, illustrés avec des chiffres et des réalisations et que par ailleurs, vous n’arriverez sans doute pas à remonter dans les résultats de recherche puisque celle-ci fonctionne avec des systèmes de mots-clefs cherchés dans votre profil.\n" +
    "C’est pourquoi je vous recommande fortement de prendre le temps de les compléter.\n" +
    "Pour rappel, notre standard, pour vous guider, est : \n" +
    "ENTREPRISE, LIEU – SERVICE, RÔLE – DURÉE (voir formulaire)\n" +
    "\t•\tContexte\n" +
    "\t•\tPérimètre d'action\n" +
    "\t•\tFournisseurs/partenaires si pertinent selon votre profil\n" +
    "\t•\tObjectifs\n" +
    "\t•\tRéalisations/Résultats\n" +
    "Regardez les profils de la page d’accueil pour vous faire une idée précise du contenu d’une fiche finalisée.\n" +
    "Excellente journée,\n" +
    "[firstname_admin]",
    replace: [
      [new RegExp('\\[firstname_fl\\]'), 'user.firstname'],
      [new RegExp('\\[firstname_admin\\]'), 'admin.firstname'],
    ]
  },
  situation: {
    value: 4,
    subject: "Votre situation nous intéresse – Twineeds",
    message: "Bonjour [firstname_fl],\n" +
    "Je souhaitais savoir quelle est votre situation actuelle. Etes-vous en mission ?\n" +
    "Si oui, dans quelle entreprise et jusqu’à quand ? Votre disponibilité est-elle à jour sur la plateforme ?\n" +
    "\n" +
    "Excellente journée,\n" +
    "\n" +
    "[firstname_admin]",
    replace: [
      [new RegExp('\\[firstname_fl\\]'), 'user.firstname'],
      [new RegExp('\\[firstname_admin\\]'), 'admin.firstname'],
    ]
  },
  profile: {
    value: 5,
    subject: "Modifications de votre profil – Twineeds",
    message: "Bonjour [firstname_fl],\n" +
    "\n" +
    "Comme évoqué lors de notre conversation, je me suis permis de retoucher à la forme de votre profil afin qu’il soit plus lisible et attractif pour nos clients. \n" +
    "N’hésitez pas à me faire part de vos remarques.\n" +
    "Bien à vous,\n" +
    "\n" +
    "[firstname_admin]",
    replace: [
      [new RegExp('\\[firstname_fl\\]'), 'user.firstname'],
      [new RegExp('\\[firstname_admin\\]'), 'admin.firstname'],
    ]
  },
  references: {
    value: 6,
    subject: "Références – Twineeds",
    message: "Bonjour [firstname_fl],\n" +
    "Tout d’abord merci pour la qualité de nos derniers échanges.\n" +
    "Lors de ce dernier entretien je vous avais indiqué que je souhaitais effectuer une prise de référence sur vos dernières expériences.\n" +
    "Cela me permettra de rassurer le client sur la qualification de votre expérience et valorisaera d’autant plus votre profil.\n" +
    "JE vous invite donc à me communiquer un contact, mail et numéro de téléphone pour vos dernières expériences significatives.\n" +
    "Je vous en remercie par avance et vous souhaite une agréable journée,\n" +
    "\n" +
    "[firstname_admin]\n",
    replace: [
      [new RegExp('\\[firstname_fl\\]'), 'user.firstname'],
      [new RegExp('\\[firstname_admin\\]'), 'admin.firstname'],
    ]
  }
}